import { Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DemoPharmaciesService {
  readonly forceIncludeDemoNcpdps = signal(false);

  constructor() {
    if (!environment.production) {
      (window as unknown as { showDemoPharmacies?: (include?: boolean) => void }).showDemoPharmacies = (include = true) =>
        this.forceIncludeDemoNcpdps.set(include);
    }
  }
}
